import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ApiList {
  baseurl: any = "/api/";
  public urlList = {
    GetSchema: "ws/DatamartWS/GetSchema",
    GetPortletDataV2: "ws/DatamartWS/GetPortletDataV2",
    GetDashboardV2: "ws/DashboardWS.asmx/GetDashboardV2",
    SaveDashboardPortlets: "ws/DashboardWS.asmx/SaveDashboardPortlets",
    GetPropertyList: "ws/CommonWS.asmx/GetPropertyList",
    LPGetPropertyList: "ws/LPCommonWS.asmx/GetPropertyList",
    GetDistinctColumnValsByPortletDataParam:
      "ws/DatamartWS/GetDistinctColumnValsByPortletDataParam",
    FileGet: "ws/FileGet.ashx",
    GetSources: "ws/DatamartWS/GetSources",
    AddDataMartTables: "ws/DashboardWS.asmx/AddDataMartTables",
    // GetPortletDataOrCreate: "ws/DatamartWS/GetPortletDataOrCreate",
    GetPortletDataOrCreate: "ws/DashboardWS.asmx/GetPortletDataOrCreate",
    GetAllCompanyByAccount: "ws/CompanyWS.asmx/GetAllCompanyByAccount", // 获取公司列表（所有数据）
    GetDropdown: "ws/CommonWS.asmx/GetDropdown", // 获取下拉菜单
    GetFinancialItems: "ws/DashboardWS.asmx/GetFinancialItems",
    GetFundListByInvestorId: "ws/FundWS.asmx/GetFundListByInvestorId",
    GetAllInvestee: "ws/DashboardWS.asmx/GetAllInvestee",
  };
}
